(function ($) {
  // Clicking on image to open details.
  $(document).on('click', '.js-image-link', function () {
    // block index
    var index = $('.js-image-link:visible').index(this);

    $('.js-description_content_block').removeClass('hidden');
    // Deatil content
    var block_content = $('.js-description_content_block:visible').eq(index).html();

    $('.js-description_content_block').addClass('hidden');
    // if Mobile  
    if (site.client.isMobile) {
      openDetailsPanelForMobile(block_content, index);
    } else {
      openDetailsPanel(block_content, index);
    }
  });

  // Clicking on read more to open details.
  $(document).on('click', '.js-read-more-link', function () {
    // block index
    var index = $('.js-read-more-link:visible').index(this);

    $('.js-description_content_block').removeClass('hidden');
    // Deatil content
    var block_content = $('.js-description_content_block:visible').eq(index).html();

    $('.js-description_content_block').addClass('hidden');
    // if Mobile  
    if (site.client.isMobile) {
      openDetailsPanelForMobile(block_content);
    } else {
      openDetailsPanel(block_content, index);
    }
  });

  // Closing details
  $(document).on('click', '.js-button--close, .js-tab-trigger', function () {
    $('.js-new_append').remove();
    $('.carousel-controls').show();
  });

  //  Opening details
  function openDetailsPanel(block_content, index) {
    // To determine how many blocks are displayed
    var screen_width = $(window).width();

    // Get complete html
    $('.js-new_append').remove();
    // New formatted html to support quick view panel - open
    var new_html = '<div class="js-new_append description_content_block">' + block_content + '</div>';
    // For large screens
    var total_blocks = $('.js-image-link:visible').length;
    var index_to_appened;
    var positions = ['block_4', 'block_3', 'block_2', 'block_1'];
    var pos;
    var class_name;

    if (screen_width > 850) {
      index_to_appened = index + (4 - index % 4);
      // getting element position to adjust pointer
      pos = index_to_appened - (index + 1);
      index_to_appened = getIndex(total_blocks, index_to_appened);
      class_name = positions[pos];
    } else if (screen_width > 700 && screen_width < 850) {
      index_to_appened = index + (3 - index % 3);
      // getting element position to adjust pointer
      pos = index_to_appened - index;
      index_to_appened = getIndex(total_blocks, index_to_appened);
      class_name = positions[pos] + '_3col';
    } else {
      index_to_appened = index;
      if (index % 2 === 0) {
        class_name = 'block_1';
        index_to_appened = index + 2;
      } else {
        class_name = 'block_2';
        index_to_appened = index + 1;
      }
      index_to_appened = getIndex(total_blocks, index_to_appened);
    }
    $('.basic-grid__item:nth-child(' + index_to_appened + ')').after(new_html);
    $('.description_content').removeClass('block_1 block_2 block_3 block_4 block_1_3col block_2_3col block_3_3col block_4_3col');
    $('.description_content').addClass(class_name);
    $('html, body').animate({
      scrollTop: $(window).scrollTop() + $('.tabbed-block__title').height() - $('.js-site-header').height()
    }, 2000);
  }

  function getIndex(block_count, index) {
    if (block_count < index) {
      return block_count;
    } else {
      return index;
    }
  }
  function openDetailsPanelForMobile(block_content, index) {
    // Get complete html
    $('.js-new_append').remove();
    // New formatted html to support quick view panel - open
    var new_html = '<div class="js-new_append description_content_block">' + block_content + '</div>';
    var class_name = '';

    $('.js-basic-carousel').after(new_html);
    // Ipad
    var screen_width = $(window).width();

    if (screen_width > 767 && screen_width < 1024) {
      if (index % 2 === 0) {
        class_name = 'block_2';
      } else {
        class_name = 'block_1';
      }
    }
    $('.description_content').removeClass('block_1 block_2 block_3 block_4 block_1_3col block_2_3col block_3_3col block_4_3col');
    $('.description_content').addClass(class_name);
    $('.carousel-controls').hide();
  }
})(window.jQuery);
